export default {
    dependencies: ['$element', 'xhrservice', 'reqwest'],
    callable(ele, xhrService, reqwest) {
        const URL = ele.getAttribute('action');
        const noteIdInput = ele.querySelector("input[name='noteId']");

        if (URL) {
            ele.addEventListener('submit', event => {
                event.preventDefault();
                event.stopPropagation();

                const note = noteIdInput
                    ? document.querySelector(`[id='note-${noteIdInput.value}']`)
                    : null;
                if (note) {
                    note.remove();
                }

                xhrService.request({
                    url: URL.replace('.html', '.json'),
                    data: reqwest.serialize(ele),
                    method: 'POST',
                    type: 'json',
                });
            });
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/favoriteNoteDelete.js